export const isTest = () => {
  return (
    window.HRBR_DEBUG ||
    (window.location.hostname &&
      (window.location.hostname === 'localhost' || window.location.hostname === 'myharbor.herokuapp.com'))
  );
};
